export default __webpack_public_path__ + "static/media/bg_m_herramientas.1ac1ea6b.png";